import ProductPriceSavingsProvider from './hooks/useProductPriceSavings';

import { ProductPriceSavingsProps } from './@types/ProductPriceSavingsProps';

//regex é só pra simular a interpolação da vtex
const ProductPriceSavings = (props: ProductPriceSavingsProps) => (
	<ProductPriceSavingsProvider {...props}>
		<span
			data-selection={props.componentId}
			className={`savings savings--${props.blockClass} vtex-product-price-1-x-savings vtex-product-price-1-x-savings--${props.blockClass}`}
		>
			{props?.message ? props.message.replace(/\{[\w]*\}/gi, '') : 'Economize '}
			<span
				className={`savingsValue savingsValue--${props.blockClass} vtex-product-price-1-x-savingsValue vtex-product-price-1-x-savingsValue--${props.blockClass}`}
			>
				<span
					className={`currencyContainer currencyContainer--${props.blockClass} vtex-product-price-1-x-currencyContainer vtex-product-price-1-x-currencyContainer--${props.blockClass}`}
				>
					<span
						className={`currencyCode currencyCode--${props.blockClass} vtex-product-price-1-x-currencyCode vtex-product-price-1-x-currencyCode--${props.blockClass}`}
					>
						R$
					</span>
					<span
						className={`currencyLiteral currencyLiteral--${props.blockClass} vtex-product-price-1-x-currencyLiteral vtex-product-price-1-x-currencyLiteral--${props.blockClass}`}
					>
						&nbsp;
					</span>
					<span
						className={`currencyInteger currencyInteger--${props.blockClass} vtex-product-price-1-x-currencyInteger vtex-product-price-1-x-currencyInteger--${props.blockClass}`}
					>
						181
					</span>
					<span
						className={`currencyDecimal currencyDecimal--${props.blockClass} vtex-product-price-1-x-currencyDecimal vtex-product-price-1-x-currencyDecimal--${props.blockClass}`}
					>
						,
					</span>
					<span
						className={`currencyFraction currencyFraction--${props.blockClass} vtex-product-price-1-x-currencyFraction vtex-product-price-1-x-currencyFraction--${props.blockClass}`}
					>
						00
					</span>
				</span>
			</span>
		</span>
	</ProductPriceSavingsProvider>
);

export default ProductPriceSavings;
